import 'css-chunk:src/components/pages/SearchPage/TextSearchFilters/AudienceLocationSection.scss';export default {
  "selectWrapper": "_selectWrapper_pjzpc_1"
};